import styled from '@emotion/styled'
import {
  Theme,
  spacing,
  Button,
  Typography as MuiTypography,
  CopyButton,
  Tooltip,
  theme,
} from '@yuno/design-system-web'

export const Wrapper = styled('div')(
  ({
    fullWidth,
    theme,
    prod,
    pending,
  }: {
    fullWidth?: boolean
    theme?: Theme
    prod?: boolean
    pending: boolean
  }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: '10px',
    boxSizing: 'border-box',
    background: theme.palette.neutral.white[0],
    border: `1px solid ${theme.palette.grey[2]}`,
    borderRadius: '4px',
    margin: '4px 4px',
    '&:hover':
      !prod || pending
        ? ''
        : {
            border: `1px solid ${theme.palette.vivid.brand}`,
            boxShadow: `0px 10px 10px ${theme.palette.neutral.shadow}`,
            borderRadius: '4px',
            '& .category': {
              display: 'none',
            },
            '& .actions': {
              display: 'grid',
            },
          },
  }),
)

export const ImgWrapper = styled.div<{
  width?: string
  height?: string
  theme?: Theme
}>`
  width: ${({ width }) => width || '60px'};
  height: ${({ height }) => height || '60px'};
  box-sizing: border-box;
  padding: 10px;
  background: ${({ theme }) => theme.palette.grey[1]};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const Title = styled(MuiTypography)<{
  theme?: Theme
  archived?: boolean
}>`
  margin-left: ${spacing.l};
  margin-right: ${spacing.l};
  margin-bottom: 10px;
  flex: 1;
  color: ${({ theme, archived }) =>
    !archived ? theme.palette.neutral.black : theme.palette.grey[3]};
  font-size: ${({ theme }) => theme.typography.base.regular.fontSize};
`

export const Description = styled(MuiTypography)<{
  theme?: Theme
  archived?: boolean
}>`
  color: ${({ theme, archived }) =>
    !archived ? theme.palette.grey[5] : theme.palette.grey[3]};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  margin-left: ${spacing.l};
`

export const Category = styled.div<{ theme?: Theme }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: start;
  color: ${({ theme }) => theme.palette.grey[5]};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  font-family: ${({ theme }) => theme.typography.tiny.regular.fontFamily};
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 6px;
  padding-right: 6px;
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  border-radius: 4px;
`

export const Pending = styled.div<{ theme?: Theme, width?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: start;
  color: ${({ theme }) => theme.palette.primary.main};
  font-size: ${({ theme }) => theme.typography.tiny.regular.fontSize};
  font-family: ${({ theme }) => theme.typography.tiny.regular.fontFamily};
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 6px;
  padding-right: 6px;
  border: 1px solid ${({ theme }) => theme.palette.grey[2]};
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.pastel.brand};
  width: ${({ width }) => width ? width : '84px'};
`
export const Action = styled('div')(({ theme }: { theme?: Theme }) => ({
  display: 'none',
}))

export const ButtonArc = styled(Button)(({ theme }: { theme?: Theme }) => ({
  '&.MuiButtonBase-root': {
    minHeight: 'unset',
    fontSize: '12px',
    padding: '5px 6px',
    float: 'right',
  },
  '& svg': {
    marginRight: '7px',
  },
}))
export const ButtonEdit = styled(Button)(({ theme }: { theme?: Theme }) => ({
  '&.MuiButtonBase-root': {
    minHeight: 'unset',
    padding: '9px 24px',
    float: 'right',
    marginTop: '14px',
  },
}))

export const ButtonDelete = styled(Button)(({ theme }: { theme?: Theme }) => ({
  '&.MuiButtonBase-root': {
    minHeight: 'unset',
    padding: '4px 6px',
    float: 'right',
    fontSize: '12px',
    margin: '28px 0px 0px 28px',
    backgroundColor: `${theme.palette.pastel.coral}`,
    color: `${theme.palette.vivid.coral}`,
    '&:hover': {
      backgroundColor: `${theme.palette.pastel.coral}`,
      color: `${theme.palette.vivid.coral}`,
    },
  },
  '& svg': {
    marginRight: '7px',
  },
}))

export const ButtonActive = styled(Button)(({ theme }: { theme?: Theme }) => ({
  '&.MuiButtonBase-root': {
    minHeight: 'unset',
    fontSize: '12px',
    padding: '5px 6px',
    float: 'right',
    margin: '0 0 0 13px',
  },
  '& svg': {
    marginRight: '7px',
  },
}))

export const TooltipStyled = styled(Tooltip)(
  ({ theme }: { theme?: Theme }) => ({
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    '& .MuiTooltip-tooltip': {
      backgroundColor: `${theme.palette.neutral.black} !important`,
      textAlign: 'center',
      border: 'none',
      width: '249px'
    },
    '& .MuiTooltip-arrow.custom-tooltip': {
      left: '-27px',
      color: theme.palette.neutral.black
    },
    '& svg': {
      marginRight: '8px',
    }
  }),
)

export const DivStyled = styled('div')(({ theme }: { theme?: Theme }) => ({
  position: 'relative',
  bottom: '27px',
  right: '10px',
  display: 'none',
}))

export const TooltipStyledCopied = styled(Tooltip)(
  ({ theme }: { theme?: Theme }) => ({
    top: '10px',
    '&.MuiTooltip-popper': {
      width: 'auto'
    }
  }),
)

export const CopyButtonStyled = {
    border: `solid ${theme.palette.grey[2]}`,
    borderRadius: '4px',
    padding: '4px',

}
